import { Link } from 'react-router-dom'
import { LayoutGrid } from 'lucide-react'
import { PRODUCT_LINKS } from '../constants/nav'

export default function Footer() {
  return (
    <footer className="bg-navy-dark py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
        <div className="grid sm:grid-cols-[1fr_auto] gap-6 items-start">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-6 bg-field-orange rounded flex items-center justify-center">
                <LayoutGrid className="w-4 h-4 text-white" />
              </div>
              <span className="text-white font-heading font-semibold">Site Deck LLC</span>
            </div>
            <p className="text-white/50 text-sm max-w-md">
              Linked construction tools for field operations, project controls, quality,
              drawings, and AI project insight.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-10 gap-y-3">
            {PRODUCT_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="text-white/60 hover:text-white text-sm transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6">
        <div className="flex items-center gap-2">
          <span className="text-white/60 text-sm">© 2026 Site Deck LLC</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="/privacy" className="text-white/60 hover:text-white text-sm transition-colors">
            Privacy
          </a>
          <a href="/terms" className="text-white/60 hover:text-white text-sm transition-colors">
            Terms
          </a>
          <a
            href="mailto:support@sitedeck.pro"
            className="text-white/60 hover:text-white text-sm transition-colors"
          >
            support@sitedeck.pro
          </a>
        </div>
        </div>
      </div>
    </footer>
  )
}
